import { useTranslation } from "react-i18next";

export function LandingMetrics() {
  const { t } = useTranslation();
  const stats = [
    { label: t("landing.metrics.companies"), value: "100+" },
    { label: t("landing.metrics.tasks_shipped"), value: "1.2M+" },
    { label: t("landing.metrics.messages_sent"), value: "5.8M+" },
    { label: t("landing.metrics.push_subs"), value: "150K+" },
    { label: t("landing.metrics.uptime"), value: "99.98%" },
  ];

  return (
    <section
      className="border-y border-zinc-200/70 bg-white"
      data-testid="landing-metrics"
    >
      <div className="mx-auto grid max-w-7xl grid-cols-2 gap-8 px-6 py-10 md:grid-cols-5 lg:px-8">
        {stats.map((s) => (
          <div key={s.label} className="text-left">
            <div className="font-display text-3xl font-extrabold tracking-tight text-zinc-950 md:text-4xl">
              {s.value}
            </div>
            <div className="mt-1 text-sm text-zinc-500">{s.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
